const UnknownErrorPage = () => {
  console.warn('Test behavior: Unknown error');
  throw new Error('This is a test error');
};

export default UnknownErrorPage;
